import { useContext } from 'react';
import { FormErrorContext } from './form-error-context';

export const useFormErrorGroup = () => {
  const {
    errors,
    unmappedErrors,
    unhandledErrors,
    showAllValidationErrors,
  } = useContext(FormErrorContext);
  return {
    errors,
    unmappedErrors,
    unhandledErrors,
    showAllValidationErrors,
  };
};
